import CurrencyDropDown from './components/dropdown/Currency';
import DefaultDropDown from './components/dropdown/Default';
import ModernDropDown from './components/dropdown/Modern';
import ModernCurrencyDropDown from './components/dropdown/ModernCurrency';

const DropDown = {
	Default: DefaultDropDown,
	Currency: CurrencyDropDown,
	Modern: ModernDropDown,
	ModernCurrency: ModernCurrencyDropDown,
};

export default DropDown;
